<template>
  <div class="login-container">
    <header>
      <div class="text">
        <span>HELLO~</span>
        <p>欢迎来到智慧校园管理平台</p>
      </div>
    </header>
    <el-form ref="form" :model="form" :rules="rules" label-width="0">
      <el-form-item prop="userName">
        <b>用户名</b>
        <el-input placeholder="请输入用户名" clearable v-model="form.userName"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <b>密码</b>
        <el-input placeholder="请输入密码" clearable v-model="form.password" show-password>
        </el-input>
      </el-form-item>
      <van-button color="var(--mainColor)" round block :loading="loading" @click.native.prevent="login">登录</van-button>
    </el-form>
    <footer class="flex-column">
      <span>Copyright©2003-2024 明杉数据</span>
      <span>All right reserved 陕ICP18279387号-1</span>
    </footer>
  </div>
</template>

<script>
const { appId, jumpURL } = projectConfig
import { loginByCodeApi, loginByPsdApi } from './api'
export default {
  name: "Login",
  data() {
    return {
      form: {
        userName: "",
        password: "",
        platformType: 2
      },
      rules: {
        userName: [{ required: true, message: "用户名不能为空", trigger: "blur" }],
        password: [{ required: true, message: "密码不能为空", trigger: "blur" }]
      },
      loading: false
    }
  },
  beforeCreate() {
    // 设备类型
    const isMobile = /Mobile|Android|iPhone/i.test(navigator.userAgent)
    if (!isMobile) return window.location.href = jumpURL
  },
  async created() {
    const { domain, code } = this.$route.query
    console.log(domain, code)
    if (domain && !code) { // 有域名无code
      const APPID = appId
      const REDIRECT_URI = encodeURIComponent(jumpURL + '/mobile')
      const SCOPE = "snsapi_base"
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=${SCOPE}&state=STATE#wechat_redirect`
    } else if (domain && code) { // 有域名有code
      const { data: { openId, token, userId } } = await loginByCodeApi(code)
      if (token) {
        localStorage.setItem('sys_token', token)
        localStorage.setItem('userId', userId)
        this.$router.push({ path: "/" })
      } else {
        this.form.openId = openId
      }
    }
  },
  methods: {
    login() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            this.loading = true
            const { data: { token, userId } } = await loginByPsdApi(this.form)
            localStorage.setItem('sys_token', token)
            localStorage.setItem('userId', userId)
            this.$router.push({ path: '/' })
          } finally {
            this.loading = false
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  height: 100vh;
  background: #fff;
  overflow: hidden;

  header {
    width: 100%;
    height: 40vh;
    background-image: linear-gradient(to top, transparent, $mainColor), url('../../assets/banner.jpg'), ;
    position: relative;
    color: #fff;

    img {
      width: 100%;
      height: 106%;
    }

    .text {
      font-size: 26px;
      position: absolute;
      top: 10vh;
      left: 6vw;
      font-weight: bold;

      span {
        font-size: 40px;
      }
    }
  }

  ::v-deep.el-form {
    background: #fff;
    // height: 100%;
    width: 90%;
    margin: auto;
    padding: 30px;
    border-radius: 30px;
    transform: translateY(-100px);

    b {
      font-size: 16px;
      color: $titleColor
    }

    .el-input__inner {
      border: none;
      border-radius: 0;
      border-bottom: 1px solid #ccc;
      padding: 0;
    }

    .el-form-item:nth-child(2) {
      margin-bottom: 50px;
    }
  }

  footer {
    font-size: 12px;
    color: $contentColor;
    gap: 5px
  }
}
</style>